






import { Component, Vue, Prop } from 'vue-property-decorator'
import CategoryImage from '@/components/media/CategoryImage.vue'
import pages from '@/constants/pages'
import { Howl } from 'howler'

@Component({
  components: {
    CategoryImage
  }
})
export default class AudioButton extends Vue {
  @Prop(Object) sound!: Howl
  @Prop(String) note!: string

  protected play () {
    this.sound.play()
  }
}
